export const TS_REGISTER = "TS_REGISTER"
export const TS_LEADERBOARD = "TS_LEADERBOARD"
export const TS_HISTORY = "TS_HISTORY"
export const TS_EVENT = "TS_EVENT"